import { factoryPermission } from "@/models";

export const PresenteeismPermission = {
  ASSOCIATES: factoryPermission("Presenteeism.Web.AssociatesFullAccess"),
  EMPLOYEES: factoryPermission("Presenteeism.Web.EmployeesFullAccess"),
  REPORT: factoryPermission("Presenteeism.Web.RerportFullAccess"),
  RUTAS: factoryPermission("Presenteeism.Web.RoutesFullAccess"),
  SEALBATCHES: factoryPermission("Presenteeism.Web.SealBatchesFullAccess"),
};
